import React from 'react';
import PropTypes from 'prop-types';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from './CustomDialog';
import { FormattedMessageWrappedInSpan } from '../../misc';

const HowToBuyOfferHintDialog = ({ open, onRequestClose }) => {
  return (
    <CustomDialog open={open} onRequestClose={onRequestClose}>
      <div className="notification-container">
        <DialogContent>
          <div className="notification-body ">
            <h1>
              <FormattedMessageWrappedInSpan
                id="howToBuyOfferHintDialog.title"
                defaultMessage="How to buy?"
              />
            </h1>
            <FormattedMessageWrappedInSpan
              id="howToBuyOfferHintDialog.description.mainBuy"
              defaultMessage="To be able to buy your personal photos, use main search first."
            />
          </div>
        </DialogContent>
        <DialogActions>
          <div className="notification-action">
            <button className="accept" onClick={onRequestClose}>
              <FormattedMessageWrappedInSpan
                id="offerTile.dialog.acceptButton"
                defaultMessage="Ok"
              />
            </button>
          </div>
        </DialogActions>
      </div>
    </CustomDialog>
  );
};

HowToBuyOfferHintDialog.propTypes = {
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
};

export default HowToBuyOfferHintDialog;
